export const stockAnalysisQueryKeys = {
  all: ['stock-analysis'] as const,
  detail: (ticker: string) => [...stockAnalysisQueryKeys.all, ticker] as const,
}
